import React from 'react';

import Carousel from 'antd/lib/carousel';

import SpecialCard from '@app/components/Pages/Specials/SpecialCard';
import { Special } from '@app/objects/Special';

import '@app/scss/components/special.scss';
import '@app/scss/components/specialsCarousel.scss';

interface Props {
	specials: Array<Special>;
}

const tabletSetting = {
	breakpoint: 821,
	settings: {
		slidesToShow: 3,
	},
};

const mobileSetting = {
	breakpoint: 500,
	settings: {
		slidesToShow: 1,
	},
};

const SpecialsCarousel: React.FC<Props> = ({ specials }) => {
	const fullScreenSlidesToShow = specials.length <= 5 ? specials.length : 5;
	const maxWidth = `${fullScreenSlidesToShow * 218}px`;

	return <div className="specials-carousel">
		<h1>Popular Specials</h1>
		<div style={{ maxWidth }}>
			<Carousel
				dots={false}
				slidesToShow={fullScreenSlidesToShow}
				slidesToScroll={1}
				className="special-list"
				responsive={[tabletSetting, mobileSetting]}
				arrows
				nextArrow={<button type="button" className="btn right">
					<i className="fa fa-chevron-right" />
				</button>}
				prevArrow={<button type="button" className="btn left">
					<i className="fa fa-chevron-left" />
				</button>}
				lazyLoad="ondemand"
			>
				{specials.map((special) =>
					<div
						key={special.id}
						className="specials-carousel__item"
					>
						<SpecialCard item={special} lazyLoad={false} />
					</div>)}
			</Carousel>
		</div>
	</div>;
};

export default SpecialsCarousel;
